import {ObjectResponse} from './object-response';
import {Helper} from './helper';

export class Neighbourhood {
  name: string;
  character: string;
  detailUrl: string;
  reducedCharacterMobile: string;
  reducedCharacterDesktop: string;

  constructor(result?: ObjectResponse<Partial<Neighbourhood>>) {
    if (result) {
      Object.assign(this, result);
      this.reducedCharacterDesktop = Helper.reduceText(this.character, 800);
      this.reducedCharacterMobile = Helper.reduceText(this.character, 400);
    }
  }
}
